'use client';

import { useAuth0AccessTokenSync } from './useAuth0AccessTokenSync';
import { useAuth0LoyaltyClaimSync } from './useAuth0LoyaltyClaimSync';
import { useSilentSsoProbe } from './useSilentSsoProbe';

/**
 * Keeps Auth0 tokens in sync with the rest of the app.
 *
 * Mounted as a child of `Auth0Provider` so `useAuth0()` is available. Access-token
 * cookie writes, 401 refresh, inactivity logout, callback navigation, silent session
 * restore, and loyalty-claim reminting each stay in their own hook. The hooks run
 * unconditionally so a callback error from token sync cannot skip the others
 * (Rules of Hooks).
 */
export function Auth0TokenSync() {
  useAuth0AccessTokenSync();
  useSilentSsoProbe();
  useAuth0LoyaltyClaimSync();
  return null;
}